export const isRequiredBuildingType = (buildingType, department) => {
  /* console.log(department) */
  /* console.log(buildingType) */
  if (department === "Patrimonio" || department === "Residencial") {
    if (buildingType.length === 0) return true;
    else return false;
  } else return false;
};

export const isDisabledBuildingType = (department) => {
  if (department === "Patrimonio" || department === "Residencial") return false;
  else return true;
};

export const getPropertyUrl = (
  property,
  currentZoneSlug,
  currentOperation,
  forcedCategory,
) => {
  // 1. MAPEADO DE CATEGORÍA
  const categoryMap = {
    residencial: "residencial",
    costa: "residencial",
    patrimonio: "patrimonio",
    "otros-activos-y-zonas": "otros-activos-y-zonas",
  };

  const rawCat = (
    forcedCategory ||
    ("category" in property ? property.category : undefined) ||
    "residencial"
  ).toLowerCase();
  const categoryUrl = categoryMap[rawCat] || "residencial";

  const formatSlug = (text) =>
    text
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-");

  // 2. CIUDAD
  const citySlug = formatSlug(
    (typeof property.location === "object" && property.location !== null
      ? "city" in property.location
        ? String(property.location.city)
        : ""
      : String(property.location)) || "madrid",
  );

  // 3. ZONA
  let zoneSegment = "";
  if (
    currentZoneSlug &&
    currentZoneSlug !== "madrid" &&
    currentZoneSlug !== "espana"
  ) {
    zoneSegment = currentZoneSlug;
  } else {
    // ✅ Uso seguro con el operador 'in'
    const rawZone =
      ("zoneName" in property ? property.zoneName : undefined) ||
      ("subzone" in property ? property.subzone : undefined) ||
      "";

    zoneSegment = rawZone ? formatSlug(String(rawZone)) : "";
  }

  // 4. OPERACIÓN
  let op = currentOperation;
  if (op === "sale") op = "venta";
  if (op === "rent") op = "alquiler";

  if (!op || op === "todos") {
    // ✅ Comprobamos si existe 'salePrice' antes de evaluarlo
    op = "salePrice" in property && property.salePrice ? "venta" : "alquiler";
  }

  // 5. CONSTRUCCIÓN DE LA RUTA
  let segments = [];

  if (categoryUrl === "otros-activos-y-zonas") {
    // 🚀 NUEVA LÓGICA: Omitimos ciudad y zona para Otros Activos
    segments = [
      categoryUrl,
      "inmuebles",
      op,
      "slug" in property ? property.slug : undefined,
    ];
  } else {
    // 🚀 LÓGICA ORIGINAL: Para Residencial y Patrimonio
    segments = [
      categoryUrl,
      citySlug,
      "inmuebles",
      zoneSegment,
      op,
      "slug" in property ? property.slug : undefined,
    ];
  }

  return `/${segments.filter(Boolean).join("/")}`;
};
const PATRIMONIAL_GROUPS = {
  PRIME: [
    "Méndez Álvaro",
    "Centro",
    "Jerónimos",
    "Salamanca",
    "Almagro",
    "Chamberí",
    "El Viso",
    "Azca",
    "Cuzco",
    "Chamartín",
    "CTBA",
    "Avenida América",
    "Madrid Secundario",
  ],
  A6: [
    "Valdemarín",
    "El Plantío",
    "Pozuelo",
    "Las Rozas",
    "PE La Finca",
    "Ciudad de la Imagen",
  ],
  A2: [
    "Arturo Soria",
    // "MADBIT",
    "Julián Camarillo",
    "Josefa Valcárcel",
    "Aeropuerto",
  ],
  A1: [
    "Arroyo de la Vega",
    "Las Tablas - Sanchinarro",
    "Campo de las Naciones",
    "Polígono Fuencarral",
    "Polígono Alcobendas",
  ],
};

const RESIDENTIAL_GROUPS = {
  "BARRIO DE SALAMANCA": [
    "Recoletos",
    "Castellana",
    "Goya",
    "Lista",
    "Fuente del Berro",
    "Guindalera",
  ],
  RETIRO: ["Jerónimos", "Ibiza", "Niño Jesús"],
  CHAMBERÍ: [
    "Almagro",
    "Chamberí",
    "Nuevos Ministerios",
    "Trafalgar",
    "Rosales",
  ],
  CENTRO: ["Justicia", "Cortes", "Palacio", "Princesa"],
  CHAMARTÍN: [
    "El Viso",
    "Hispanoamérica",
    "Nueva España",
    "Ciudad Jardín",
    "Prosperidad",
    "Orense - Cuzco",
  ],
  MIRASIERRA: ["Mirasierra", "Montecarmelo"],
  "PUERTA DE HIERRO": [
    // "Colonia Puerta de Hierro",
    // "Zona Puerta de Hierro",
    "Puerta de Hierro",
    "Colonia Fuentelarreyna",
    "Arroyo del Fresno",
    "Peñagrande",
  ],
  A6: ["Aravaca", "Valdemarín", "La Florida", "El Plantío", "Majadahonda"],
  POZUELO: [
    "Pozuelo",
    "Somosaguas",
    // "Somosaguas A",
    // "Somosaguas Norte",
    "La Finca",
    "Las Encinas",
    "Montealina",
    "Monteclaro",
    "Prado Largo",
    // "Alamo de Bularas",
    "Álamo de Bularas",
    "Montepríncipe",
    "La Cabaña",
  ],
  A2: ["Arturo Soria", "Conde de Orgaz"],
  MORALEJA: [
    "La Moraleja",
    "El Soto",
    "El encinar",
    "Solana de Valdebebas",
    "Valdebebas",
    "Sanchinarro",
    "Las Tablas",
  ],
  A1: [
    "Fuente del Fresno",
    "Ciudalcampo",
    "Santo Domingo",
    // "Urbanizaciones A-1",
  ],
  M50: ["Las Rozas", "Villaviciosa de Odón", "El Bosque", "Boadilla del Monte"],
};

const RUSTIC_SINGULAR_GROUPS = {
  Otros: ["Otros"],
};

export { PATRIMONIAL_GROUPS, RESIDENTIAL_GROUPS, RUSTIC_SINGULAR_GROUPS };

export const organizeZonesByGroup = (zones, groupMap) => {
  if (!zones) return [];

  const findGroupName = (name) => {
    const nameLow = name?.toLowerCase().trim();

    // Si es "Periferia", devolvemos un marcador (null) para identificar que debe ser excluida
    if (nameLow === "periferia") return null;

    return (
      Object.keys(groupMap).find((key) =>
        groupMap[key].some((z) => z.toLowerCase().trim() === nameLow),
      ) || "Otros"
    );
  };

  const groupOrder = [...Object.keys(groupMap), "Otros"];

  return (
    zones
      .map((item) => ({
        ...item,
        zone: findGroupName(item.name),
      }))
      // FILTRO: Solo mantenemos los elementos cuyo grupo NO sea null
      .filter((item) => item.zone !== null)
      .sort((a, b) => {
        const indexA = groupOrder.indexOf(a.zone);
        const indexB = groupOrder.indexOf(b.zone);

        if (indexA !== indexB) return indexA - indexB;
        return a.name.localeCompare(b.name);
      })
  );
};

export const organizeCostaZones = (zones) => {
  if (!zones || zones.length === 0) return [];

  return zones
    .map((item) => ({
      ...item,
      zone: item.subzone ? item.subzone.toUpperCase() : "OTROS",
    }))
    .sort((a, b) => {
      if (a.zone === "OTROS" && b.zone !== "OTROS") return 1;
      if (a.zone !== "OTROS" && b.zone === "OTROS") return -1;

      // Orden alfabético para los nombres de los grupos
      if (a.zone !== b.zone) return a.zone.localeCompare(b.zone);

      // Orden alfabético para las zonas dentro del grupo
      return a.name.localeCompare(b.name);
    });
};

export const ALL_BUILDING_TYPES = {};

export const BUILDING_TYPES_BY_DEPARTMENT = {
  Patrimonio: [
    { value: "Oficina", label: "Oficina" },
    { value: "Edificio", label: "Edificio" },
    { value: "Local", label: "Local" },
    { value: "Nave", label: "Nave" },
    { value: "Suelo", label: "Suelo" },
  ],
  "Campos Rústicos & Activos Singulares": [
    { value: "Finca", label: "Finca" },
    { value: "Casa de Campo", label: "Casa de Campo" },
    { value: "Activo Singular", label: "Activo Singular" },
  ],
  Costa: [
    { value: "Casa", label: "Casa" },
    { value: "Piso", label: "Piso" },
    { value: "Ático", label: "Ático" },
    { value: "Bajo", label: "Bajo" },
    { value: "Parcela", label: "Parcela" },
  ],
  Otros: [
    { value: "Activos singulares", label: "Activos singulares" },
    { value: "Costa", label: "Costa" },
    { value: "Campo Rústico", label: "Campo Rústico" },
  ],
  Residencial: [
    { value: "Casa", label: "Casa" },
    { value: "Piso", label: "Piso" },
    { value: "Parcela", label: "Parcela" },
    { value: "Ático", label: "Ático" },
  ],
};

export const getAvailableBuildingTypes = (currentZone) => {
  return (
    BUILDING_TYPES_BY_DEPARTMENT[currentZone] ||
    BUILDING_TYPES_BY_DEPARTMENT.Residencial
  );
};
